export function getCommercePaginationInitialState() {
    return {
        principal: getCommercePaginationInitialSlice(),
        recommendations: {},
    };
}
export function getCommercePaginationInitialSlice() {
    return {
        page: 0,
        perPage: 0,
        totalEntries: 0,
        totalPages: 0,
    };
}
